/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

export interface CalendarData {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  calendarId?: number;
  subject?: string;
  caseName?: string;
  location?: string | null;
  /** @format date-time */
  startTime?: string | null;
  /** @format date-time */
  endTime?: string | null;
  isAllDay?: boolean;
}

export interface DashboardCase {
  caseNumber?: string | null;
  caseTitle?: string | null;
  decision?: string | null;
  judicialAssignments?: string[] | null;
  /** @format date */
  conferenceDate?: string | null;
  /** @format date-time */
  oralHearingDateTime?: string | null;
  location?: string | null;
}

export interface CaseDropdownDTO {
  regions?: CaseDropdownRegion[];
  dispositions?: DispositionDTO[];
  counties?: FilingCountyDTO[];
  docTypes?: CodeDTO[];
  agencies?: CodeDTO[];
  denialCodes?: CodeDTO[];
  caseTypes?: CodeDTO[];
  subStatuses?: CodeDTO[];
  claimTypes?: CodeDTO[];
  crimeVictimCodes?: CodeDTO[];
  victimRaceCodes?: CodeDTO[];
  feeWaiverOptions?: FeeWaiverDTO[];
  prisonCodes?: CodeDTO[];
  ageRanges?: CodeDTO[];
  genders?: CodeDTO[];
  determinationCategories?: CodeDTO[];
  determinations?: CodeDTO[];
  determinationVictimTypes?: CodeDTO[];
  determinationAwardTypes?: CodeDTO[];
  queues?: SelectionValueOfGuid[];
}

export interface CaseDropdownRegion {
  /** @format guid */
  id?: string | null;
  name?: string;
}

export interface DispositionDTO {
  /** @format guid */
  id?: string | null;
  type?: number | null;
  name?: string;
}

export type FilingCountyDTO = PostFilingCountyDTO & {
  name?: string;
  code?: string;
};

export interface PostFilingCountyDTO {
  /** @format guid */
  id?: string | null;
}

export interface CodeDTO {
  /** @format guid */
  id?: string | null;
  name?: string;
  code?: string;
  typeName?: string;
  type?: CodeType;
  metadata?: CodeMetadata;
}

export enum CodeType {
  CaseType = 0,
  ClaimType = 1,
  Agency = 2,
  County = 3,
  Denial = 4,
  CrimeVictim = 5,
  VictimRace = 6,
  SubStatus = 7,
  Prison = 8,
  AgeRange = 9,
  Gender = 10,
  DocType = 11,
  DeterminationCategory = 12,
  Determination = 13,
  DeterminationVictimType = 14,
  DeterminationAwardType = 15,
  DeterminationDisposition = 16,
  Unknown = -1,
}

export interface CodeMetadata {
  claimType?: ClaimTypeMetadata | null;
  prison?: PrisonMetadata | null;
  availableDocTypes?: string[] | null;
  docType?: DocTypeMetadata | null;
  availableDeterminations?: string[] | null;
}

export interface ClaimTypeMetadata {
  /** @format int32 */
  suspenseDate?: number;
  feeWaiverable?: boolean;
  feeRequired?: boolean | null;
  allowAgencies?: boolean | null;
  allowedAgencies?: number[];
}

export interface PrisonMetadata {
  address1?: string;
  city?: string;
  state?: string;
  zip?: string;
}

export interface DocTypeMetadata {
  filingTypeRestriction?: DocumentFilingType | null;
  categoryRestriction?: DocumentCategory | null;
  availability?: DocTypeAvailability[];
  docExtensions?: string[] | null;
  isDLIR?: boolean | null;
}

export enum DocumentFilingType {
  InitialFiling = 0,
  ExistingFiling = 1,
  All = -1,
}

export enum DocumentCategory {
  ALL = 0,
  MAIN = 1,
  SUPP = 2,
}

export interface DocTypeAvailability {
  caseType?: CaseType;
  category?: DocumentCategory;
  filingType?: DocumentFilingType;
}

export enum CaseType {
  General = 0,
  CrimeVictim = 1,
  All = 2,
}

export interface FeeWaiverDTO {
  /** @format int32 */
  value?: number;
  label?: string;
}

export interface SelectionValueOfGuid {
  /** @format guid */
  value?: string;
  label?: string;
}

export interface CaseDetailsDTO {
  /** @format guid */
  id?: string;
  caseNum?: string;
  status?: CaseStatus;
  caseName?: string;
  isConsolidated?: boolean;
  consolidatedCaseNum?: string | null;
  /** @format date-time */
  dateFiled?: string | null;
  /** @format date-time */
  dateAppealed?: string | null;
  /** @format date-time */
  dateActionAppealed?: string | null;
  /** @format date-time */
  dateCertified?: string | null;
  /** @format date-time */
  dateCertifiedDue?: string | null;
  participants?: CaseParticipantDTO[];
  isAppealed?: boolean;
  caseType?: CodeDTO;
  claimType?: CodeDTO;
  agency?: CodeDTO;
  denialCode?: CodeDTO | null;
  subStatus?: CodeDTO | null;
  /** @format decimal */
  claimAmount?: number | null;
  /** @format date-time */
  incidentDate?: string | null;
  crimeVictimCode?: CodeDTO | null;
  feeWaiverRequest?: FeeWaiverDTO;
  prisonCode?: CodeDTO | null;
  invoiceNum?: string | null;
  invoiceNums?: string[] | null;
  warrantNum?: string | null;
  /** @format date-time */
  suspenseDate?: string | null;
  voucherAwarded?: boolean | null;
  /** @format date-time */
  voucherAwardedDate?: string | null;
  /** @format decimal */
  voucherAwardedAmount?: number | null;
  /** @format date-time */
  dateClosed?: string | null;
  /** @format date-time */
  dateReopened?: string | null;
  dockets?: DocketEntry[];
  fees?: LineItem[];
  /** @format guid */
  queueId?: string | null;
}

export enum CaseStatus {
  Pending = 0,
  Active = 1,
  Closed = 2,
}

export interface CaseParticipantDTO {
  /** @format guid */
  id?: string | null;
  status?: ParticipantStatus;
  type?: ParticipantType;
  name?: string;
  address?: PostFilingAddressDTO | null;
  /** @format guid */
  userId?: string | null;
  isProSe?: boolean;
  phoneNumber?: string | null;
  claimantRaceCode?: CodeDTO | null;
  ageRangeCode?: CodeDTO | null;
  genderCode?: CodeDTO | null;
  survivingDependant?: string | null;
  survivingDependants?: string[];
  /** @format int32 */
  dependentCount?: number | null;
  ssn?: string | null;
  cvName?: string | null;
  prisonerNum?: string | null;
  claimantEmail?: string | null;
  warrantNum?: string | null;
  warrantNums?: string[] | null;
  county?: CodeDTO | null;
  decedentName?: string | null;
  ssnUpdate?: SsnUpdate | null;
  isNAOF?: boolean | null;
  attorneys?: CaseParticipantAttorneyDTO[];
}

export enum ParticipantStatus {
  Inactive = 0,
  Active = 1,
}

export enum ParticipantType {
  Claimant = 0,
  Respondant = 1,
  Judge = 2,
  Staff = 3,
}

export interface PostFilingAddressDTO {
  address1?: string;
  address2?: string | null;
  city?: string;
  state?: string;
  zip?: string;
  attention?: string | null;
}

export interface SsnUpdate {
  /** @format int32 */
  newSSN?: number | null;
}

export interface CaseParticipantAttorneyDTO {
  /** @format guid */
  id?: string | null;
  /** @format guid */
  attorneyId?: string;
  /** @format guid */
  userId?: string;
  email?: string | null;
  firmName?: string | null;
  fName?: string;
  mName?: string | null;
  lName?: string;
  address?: PostFilingAddressDTO | null;
  status?: ParticipantStatus;
  phoneNumber?: string;
}

export interface DocketEntry {
  /** @format guid */
  filingId?: string;
  /** @format date-time */
  filingDate?: string;
  description?: string | null;
  ehbDisposition?: DispositionDTO;
  commonwealthDisposition?: DispositionDTO;
  documents?: GetFilingDocDTO[];
}

export type GetFilingDocDTO = PostFilingDocDTO & {
  determination?: GetFilingDocDetermination | null;
};

export type GetFilingDocDetermination = PostFilingDocDetermination & {
  determinationCategory?: CodeDTO | null;
  determination?: CodeDTO | null;
  determinationVictimTypes?: CodeDTO[] | null;
  determinationAwards?: DeterminationAwardOfCodeDTO[] | null;
};

export interface DeterminationAwardOfCodeDTO {
  award?: CodeDTO | null;
  /** @format decimal */
  awardValue?: number;
}

export interface PostFilingDocDetermination {
  /** @format guid */
  determinationCategoryId?: string | null;
  /** @format guid */
  determinationId?: string | null;
  determinationVictimTypes?: string[];
  determinationAwards?: DeterminationAwardOfGuid[];
  /** @format int32 */
  supplementalDeterminationNum?: number | null;
  /** @format guid */
  determinationDisposition?: string | null;
  determinationDispositionReason?: string | null;
}

export interface DeterminationAwardOfGuid {
  /** @format guid */
  award?: string;
  /** @format decimal */
  awardValue?: number;
}

export interface PostFilingDocDTO {
  /** @format guid */
  documentId?: string | null;
  mainDocument?: boolean;
  description?: string;
  fileName?: string;
  displayName?: string;
  fileURI?: string;
  secured?: boolean;
  /** @format int32 */
  index?: number;
  status?: ParticipantStatus | null;
  /** @format guid */
  docType?: string | null;
  docTypeName?: string | null;
  determination?: PostFilingDocDetermination | null;
}

export interface LineItem {
  identifiers?: string[];
  /** @format decimal */
  amount?: number;
  paymentType?: string;
}

export interface PostCaseRequest {
  caseStatus?: CaseStatus;
  participants?: CaseParticipantDTO[];
  /** @format guid */
  region?: string | null;
  isConsolidatedCase?: boolean;
  consolidatedCaseNum?: string | null;
  /** @format date-time */
  dateFiled?: string | null;
  /** @format date-time */
  dateAppealed?: string | null;
  /** @format date-time */
  dateActionAppealed?: string | null;
  /** @format date-time */
  dateCertified?: string | null;
  /** @format date-time */
  dateCertifiedDue?: string | null;
  caseName?: string | null;
  isAppealed?: boolean;
  /** @format guid */
  agencyId?: string | null;
  /** @format guid */
  denialCodeId?: string | null;
  /** @format guid */
  caseType?: string;
  /** @format guid */
  subStatusId?: string | null;
  /** @format guid */
  claimTypeId?: string | null;
  /** @format decimal */
  claimAmount?: number | null;
  /** @format date-time */
  incidentDate?: string | null;
  /** @format guid */
  crimeVictimId?: string | null;
  feeWaiverRequested?: boolean | null;
  /** @format guid */
  prisonCodeId?: string | null;
  invoiceNum?: string | null;
  invoiceNums?: string[];
  warrantNum?: string | null;
  /** @format date-time */
  suspenseDate?: string | null;
  voucherAwarded?: boolean | null;
  /** @format date-time */
  voucherAwardedDate?: string | null;
}

export interface CaseListDTO {
  /** @format guid */
  caseId?: string;
  caseNum?: string | null;
  caseStatus?: number;
  judgePrefix?: string | null;
  judgeFirst?: string | null;
  judgeMiddle?: string | null;
  judgeLast?: string | null;
}

export interface CasePartyUpdateRequest {
  /** @format guid */
  caseId?: string;
  /** @format guid */
  participantId?: string;
  /** @format guid */
  participantAttorneyId?: string | null;
  /** @format guid */
  attorneyId?: string | null;
}

export interface CaseAddParticipantRequest {
  /** @format guid */
  caseId?: string;
  /** @format guid */
  userId?: string | null;
  participantType?: ParticipantType;
  name?: string;
  address?: PostFilingAddressDTO | null;
  /** @format guid */
  raceCodeId?: string | null;
}

export interface DocketListResponse {
  caseNumber?: string;
  respondantName?: string;
  filings?: FilingDTO[];
}

export type FilingDTO = PostFilingDTO & {
  rejectionReason?: string | null;
  /** @format date-time */
  reviewDate?: string | null;
  region?: FilingRegion;
  /** @format int32 */
  confirmationNumber?: number | null;
  filerName?: string | null;
  caseNum?: string | null;
  dispositionEHBName?: string | null;
  dispositionCommonwealthName?: string | null;
  documents?: GetFilingDocDTO[];
  participants?: GetFilingParticipantDTO[];
  description?: string | null;
  agency?: CodeDTO | null;
  denialCode?: CodeDTO | null;
  caseType?: CodeDTO | null;
  claimType?: CodeDTO | null;
  crimeVictimCode?: CodeDTO | null;
  prisonCode?: CodeDTO | null;
  feeWaiverStatus?: FeeWaiverDTO | null;
  assignedQueue?: QueueInfo | null;
  copyOfConfirmationNum?: string | null;
  /** @format guid */
  determinationDisposition?: string | null;
  determinationDispositionReason?: string | null;
  /** @format guid */
  courtId?: string;
  /** @format guid */
  countyId?: string | null;
};

export type FilingRegion = PostFilingRegion & {
  name?: string | null;
};

export interface PostFilingRegion {
  /** @format guid */
  id?: string | null;
}

export type GetFilingParticipantDTO = PostFilingParticipantDTO & {
  attorneys?: FilingResponseAttorney[];
  claimantRaceCode?: CodeDTO | null;
  ageRangeCode?: CodeDTO | null;
  genderCode?: CodeDTO | null;
  ssn?: string | null;
  countyCode?: CodeDTO | null;
  isNAOF?: boolean | null;
};

export type FilingResponseAttorney = PostFilingAttorneyDTO & {
  /** @format guid */
  attorneyId?: string | null;
  name?: string | null;
  applyToAll?: boolean | null;
};

export interface PostFilingAttorneyDTO {
  /** @format guid */
  attorneyId?: string;
  applyToAll?: boolean;
}

export interface PostFilingParticipantDTO {
  /** @format guid */
  id?: string | null;
  name?: string;
  type?: ParticipantType;
  address?: PostFilingAddressDTO | null;
  phoneNumber?: string | null;
  attorneys?: PostFilingAttorneyDTO[];
  isProSeUser?: boolean;
  /** @format guid */
  userId?: string | null;
  /** @format guid */
  claimantRaceCodeId?: string | null;
  /** @format guid */
  ageRangeCodeId?: string | null;
  /** @format guid */
  genderCodeId?: string | null;
  survivingDependant?: string | null;
  survivingDependants?: string[] | null;
  /** @format int32 */
  dependentsCount?: number | null;
  /** @format int32 */
  ssn?: number | null;
  crimeVictimName?: string | null;
  prisonerNum?: string | null;
  claimantEmail?: string | null;
  warrantNum?: string | null;
  warrantNums?: string[] | null;
  /** @format guid */
  county?: string | null;
  decedentName?: string | null;
}

export interface QueueInfo {
  /** @format guid */
  id?: string;
  name?: string;
  type?: QueueType;
}

export enum QueueType {
  CourtQueue = 0,
  CVQueue = 1,
  ClerkQueue = 2,
  FilingReview = 3,
  Unknown = -1,
}

export interface PostFilingDTO {
  /** @format guid */
  courtId?: string;
  /** @format guid */
  countyId?: string | null;
  /** @format guid */
  filingId?: string | null;
  /** @format guid */
  filerId?: string | null;
  /** @format guid */
  draftFilingId?: string | null;
  /** @format guid */
  caseId?: string | null;
  /** @format guid */
  caseTypeId?: string | null;
  /** @format guid */
  claimTypeId?: string | null;
  filingType?: FilingType;
  region?: PostFilingRegion;
  /** @format date-time */
  dateSubmitted?: string | null;
  /** @format date-time */
  dateSubmittedActual?: string | null;
  participants?: PostFilingParticipantDTO[];
  documents?: PostFilingDocDTO[];
  /** @format guid */
  dispositionId?: string | null;
  /** @format guid */
  dispositionCommonwealthId?: string | null;
  /** @format guid */
  agencyId?: string | null;
  /** @format guid */
  prisonCodeId?: string | null;
  /** @format guid */
  denialCodeId?: string | null;
  /** @format decimal */
  claimAmount?: number | null;
  /** @format date-time */
  incidentDate?: string | null;
  /** @format guid */
  crimeVictimId?: string | null;
  feeWaiverRequested?: boolean | null;
  invoiceNumber?: string | null;
  invoiceNumbers?: string[] | null;
  /** @format date-time */
  suspenseDate?: string | null;
  /** @format decimal */
  awardAmount?: number | null;
  /** @format guid */
  copyOf?: string | null;
}

export enum FilingType {
  InitialFiling = 0,
  ExistingFiling = 1,
}

export interface PostDocketDTO {
  /** @format guid */
  caseId?: string;
  /** @format date-time */
  dateFiled?: string;
  /** @format guid */
  dispositionEHBId?: string | null;
  /** @format guid */
  dispositionCommonwealthId?: string | null;
  description?: string | null;
  documents?: PostFilingDocDTO[];
  /** @format guid */
  agencyId?: string | null;
  /** @format guid */
  denialCodeId?: string | null;
  /** @format decimal */
  claimAmount?: number | null;
  /** @format date-time */
  incidentDate?: string | null;
}

export interface PatchDocketRequest {
  /** @format guid */
  filingId?: string;
  description?: string | null;
  /** @format guid */
  disposition?: string | null;
  /** @format guid */
  commonwealthDisposition?: string | null;
  /** @format date-time */
  dateSubmitted?: string;
  documents?: PostFilingDocDTO[];
  /** @format decimal */
  awardAmount?: number | null;
}

export interface JudicialAssignment {
  /** @format guid */
  caseId?: string;
  caseNum?: string;
  caseName?: string;
  caseStatus?: string;
  /** @format date-time */
  dateAdded?: string;
  assignedJudge?: string;
  caseType?: string;
  bookmarked?: boolean;
  hasNotes?: boolean;
  /** @format date-time */
  suspenseDate?: string | null;
  tags?: CaseTag[];
}

export interface CaseTag {
  /** @format guid */
  id?: string;
  label?: string;
}

export interface JudicialAssignmentQuery {
  /** @format guid */
  judgeUserId?: string | null;
  /** @format date-time */
  dateFrom?: string | null;
  /** @format date-time */
  dateTo?: string | null;
  bookmarksOnly?: boolean;
  description?: string | null;
  caseStatus?: ReportsCaseStatus;
  caseType?: ReportsCaseType;
  showSuspenseDate?: boolean;
  showRemoved?: boolean;
  tags?: string[];
}

export enum ReportsCaseStatus {
  Active = 1,
  Closed = 2,
  All = -1,
}

export enum ReportsCaseType {
  General = 0,
  CrimeVictim = 1,
  All = -1,
}

export interface ResponseMessages {
  messages?: string[];
  warningMessages?: string[];
}

export interface DashboardCountsDTO {
  /** @format int64 */
  filingDrafts?: number;
  /** @format int64 */
  filingDraftCopies?: number | null;
  /** @format int64 */
  filingPending?: number;
  /** @format int64 */
  filingAccepted?: number;
  /** @format int64 */
  filingRejected?: number;
  /** @format int64 */
  filingReturned?: number | null;
  /** @format int64 */
  documentPending?: number;
  /** @format int64 */
  documentAccepted?: number;
  /** @format int64 */
  documentRejected?: number;
  /** @format int64 */
  usersPending?: number;
  queueCounts?: DashboardQueueCountsDTO[];
  judicialAssignments?: string | null;
}

export interface DashboardQueueCountsDTO {
  /** @format guid */
  queueId?: string;
  queueName?: string;
  queueType?: QueueType;
  /** @format int64 */
  count?: number;
}

export interface DocketSearchResponse {
  /** @format guid */
  caseId?: string;
  /** @format date-time */
  docketDate?: string;
  caseNumber?: string;
  caseName?: string;
  caseStatus?: string;
  participantName?: string;
  participantType?: string;
  presidingJudge?: string;
  counsels?: string[];
  region?: string;
  consolidatedCaseNum?: string | null;
  caseType?: string;
  claimType?: string | null;
}

export enum SortableColumnCase {
  Date = 0,
  CaseNumber = 1,
  Judge = 2,
  CaseStatus = 3,
  Region = 4,
}

export type DocumentSearchResponse = DocketSearchResponse & {
  docDescription?: string;
  docURI?: string;
  /** @format guid */
  documentId?: string;
  /** @format guid */
  filingId?: string;
};

export enum SortableColumnDocument {
  Date = 0,
  CaseNum = 1,
}

export enum SortableColumnParticipant {
  Date = 0,
  CaseNum = 1,
  Name = 2,
  Type = 3,
}

export interface DocketSearchDropdownsResponse {
  regions?: CaseDropdownRegion[];
  judges?: DocketSearchDropdownsParticipant[];
  assistantCounsels?: DocketSearchDropdownsParticipant[];
  partyTypes?: DocketSearchDropdownsParty[];
  caseTypes?: CodeDTO[];
  claimTypes?: CodeDTO[];
  keywordOperators?: DocketSearchDropdownsKeywordOperators[];
}

export interface DocketSearchDropdownsParticipant {
  /** @format guid */
  id?: string | null;
  name?: string;
}

export interface DocketSearchDropdownsParty {
  /** @format int32 */
  type?: number;
  name?: string;
}

export interface DocketSearchDropdownsKeywordOperators {
  value?: KeywordSearchOperators;
  label?: string;
}

export enum KeywordSearchOperators {
  NONE = 0,
  AND = 1,
  OR = 2,
  NOT = 3,
  WITHINAHEAD = 4,
  WITHINBIDIRECTIONAL = 5,
}

export interface KeywordSearchResponse {
  /** @format int32 */
  occurrence?: number;
  /** @format date-time */
  dateAdded?: string;
  assignedJudge?: string;
  caseNumber?: string;
  programAreaName?: string;
  docDescription?: string;
  docURI?: string;
  /** @format guid */
  documentId?: string;
  /** @format guid */
  filingId?: string;
  participantNames?: string;
}

export interface KeywordSearchRequest {
  /** @format date-time */
  dateFrom?: string | null;
  /** @format date-time */
  dateTo?: string | null;
  /** @format guid */
  assignedJudge?: string | null;
  /** @format guid */
  programArea?: string | null;
  searchContexts?: KeywordSearchContext[];
  filterContent?: string;
}

export interface KeywordSearchContext {
  /** @format int32 */
  index?: number;
  keyword?: string;
  operator?: KeywordSearchOperators | null;
  /** @format int32 */
  range?: number | null;
}

export interface DocumentListResponse {
  hasSecured?: boolean;
  caseNum?: string | null;
  confirmationNum?: string;
  documents?: PostFilingDocDTO[];
}

export interface ImportDocumentRequest {
  originalFileName?: string;
  displayName?: string;
  contentType?: string;
  /** @format uri */
  uri?: string;
}

export interface ImportLoadDocumentRequest {
  /** @format guid */
  filingId?: string;
  /** @format guid */
  documentId?: string;
  description?: string;
  fileName?: string;
  /** @format byte */
  fileData?: string;
}

export interface FilingDropdownDTO {
  counties?: FilingCountyDTO[];
  dispositions?: DispositionDTO[];
  filingTypes?: FilingTypeDTO[];
  filingTypesEnum?: FilingType[];
  docTypes?: CodeDTO[];
  agencies?: CodeDTO[];
  denialCodes?: CodeDTO[];
  caseTypes?: CodeDTO[];
  claimTypes?: CodeDTO[];
  crimeVictimCodes?: CodeDTO[];
  victimRaceCodes?: CodeDTO[];
  prisonCodes?: CodeDTO[];
  ageRanges?: CodeDTO[];
  genders?: CodeDTO[];
  determinationCategories?: CodeDTO[];
  determinations?: CodeDTO[];
  determinationVictimTypes?: CodeDTO[];
  determinationAwardTypes?: CodeDTO[];
  courts?: CourtDTO[];
}

export interface FilingTypeDTO {
  /** @format int32 */
  value?: number;
  label?: string;
}

export interface CourtDTO {
  /** @format guid */
  courtId?: string;
  courtName?: string;
}

export interface FilingListResponse {
  /** @format guid */
  id?: string;
  status?: CaseFilingStatus;
  filingType?: FilingType;
  /** @format int32 */
  confirmationNumber?: number | null;
  docketNumber?: string | null;
  rejectionReason?: string | null;
  /** @format date-time */
  dateCreated?: string;
  /** @format date-time */
  dateFiled?: string | null;
  /** @format date-time */
  dateReviewed?: string | null;
  participants?: FilingListResponseUser[];
  attorneys?: FilingListResponseUser[];
  mainDoc?: FilingListResponseDoc | null;
  suppDocs?: FilingListResponseDoc[];
  filerName?: string | null;
  feeWaiverRequested?: string;
  /** @format guid */
  caseTypeId?: string | null;
  caseTypeName?: string;
  /** @format guid */
  claimTypeId?: string | null;
  claimTypeName?: string;
  /** @format guid */
  reviewerId?: string | null;
  bookmarked?: boolean | null;
  /** @format guid */
  copyOf?: string | null;
  /** @format guid */
  assignedTo?: string | null;
  copyOfConfirmationNumber?: string | null;
  dlirType?: string | null;
}

export enum CaseFilingStatus {
  Draft = 0,
  Pending = 1,
  Accepted = 2,
  Rejected = 3,
  Deleted = 4,
  Returned = 5,
}

export interface FilingListResponseUser {
  /** @format guid */
  id?: string | null;
  participantType?: ParticipantType | null;
  name?: string;
}

export interface FilingListResponseDoc {
  /** @format guid */
  id?: string | null;
  fileURI?: string;
  docTitle?: string | null;
  displayName?: string | null;
  docDesc?: string | null;
  secured?: boolean;
  /** @format int32 */
  index?: number;
}

export enum SortableColumnsFiling {
  CaseNumber = 0,
  ReviewDate = 1,
  FilerName = 2,
  DateAdded = 3,
  FilingType = 4,
}

export interface AssignDraftDTO {
  /** @format guid */
  draftId?: string;
  /** @format guid */
  assignedTo?: string | null;
}

export interface BatchRejectResponse {
  message?: string;
}

export interface GetParticipantDetailsResponse {
  participant?: GetParticipantDetailsResponseUser;
  attorneys?: GetParticipantDetailsResponseUser[];
}

export interface GetParticipantDetailsResponseUser {
  /** @format guid */
  id?: string;
  name?: string;
  address1?: string;
  address2?: string | null;
  city?: string;
  state?: string;
  zip?: string;
  phoneNumber?: string | null;
  survivingDependant?: string | null;
}

export interface FilingRejectRequest {
  rejectReason?: string | null;
}

export interface FilingCounts {
  /** @format int32 */
  draft?: number;
  /** @format int32 */
  draftCopies?: number | null;
  /** @format int32 */
  pending?: number;
  /** @format int32 */
  accepted?: number;
  /** @format int32 */
  rejected?: number;
  /** @format int32 */
  returned?: number | null;
}

export interface UpdateFilingRequest {
  /** @format guid */
  reviewerId?: string | null;
}

export interface QueueUserListSimple {
  /** @format guid */
  userId?: string;
  name?: string;
  role?: QueuePermissions;
}

export enum QueuePermissions {
  Member = 0,
  Manager = 1,
}

export interface NoteRequest {
  /** @format guid */
  parentId?: string;
  content?: string;
  taggedUsers?: string[];
}

export interface NoteDTO {
  /** @format guid */
  id?: string;
  content?: string;
  /** @format date-time */
  dateCreated?: string;
  /** @format guid */
  authorId?: string;
  authorName?: string;
  caseNumber?: string;
}

export enum FeeWaiverRequest {
  UnRequested = 0,
  Requested = 1,
  Granted = 2,
  Denied = 3,
}

export interface GetTransactionResponse {
  /** @format int32 */
  paymentReceiptConfirmation?: number | null;
  /** @format date-time */
  transactionDate?: string;
  lastFour?: string;
  paymentMethod?: PaymentMethod;
  paymentMethodDesc?: string;
  lineItems?: LineItem[];
}

export enum PaymentMethod {
  CreditCard = 0,
  ECheck = 1,
  DebitCard = 2,
  Cash = 3,
  PaperCheck = 4,
  Free = 5,
}

export interface QueueDropdowns {
  queues?: SelectionValueOfGuid[];
  queueRoles?: SelectionValueOfNullableQueuePermissions[];
  userTypes?: SelectionValueOfNullableUserTypes[];
  dispositions?: DispositionDTO[];
  counties?: FilingCountyDTO[];
  docTypes?: CodeDTO[];
  agencies?: CodeDTO[];
  denialCodes?: CodeDTO[];
  caseTypes?: CodeDTO[];
  subStatuses?: CodeDTO[];
  claimTypes?: CodeDTO[];
  crimeVictimCodes?: CodeDTO[];
  victimRaceCodes?: CodeDTO[];
  feeWaiverOptions?: FeeWaiverDTO[];
  prisonCodes?: CodeDTO[];
  ageRanges?: CodeDTO[];
  genders?: CodeDTO[];
  determinationCategories?: CodeDTO[];
  determinations?: CodeDTO[];
  determinationVictimTypes?: CodeDTO[];
  determinationAwardTypes?: CodeDTO[];
  determinationDispositions?: CodeDTO[];
}

export interface SelectionValueOfNullableQueuePermissions {
  value?: QueuePermissions | null;
  label?: string;
}

export interface SelectionValueOfNullableUserTypes {
  value?: UserTypes | null;
  label?: string;
}

export enum UserTypes {
  Attorney = 0,
  ProSe = 1,
  Judge = 2,
  CourtAdmin = 3,
  JudicialStaff = 4,
  ClerkAdmin = 5,
  Commissioner = 6,
  AttorneyGeneralCC = 7,
  FSXSupport = 8,
  ClerkStaff = 9,
  CourtStaff = 10,
  CVManager = 11,
  JudgeAdmin = 12,
  AttorneyGeneralCV = 13,
  AGAdminCC = 14,
  AGAdminCV = 15,
  AGStaffCC = 16,
  AGStaffCV = 17,
  CVStaff = 18,
  StateAgency = 19,
}

export interface QueueItemList {
  /** @format guid */
  id?: string;
  bookmarked?: boolean;
  /** @format guid */
  caseId?: string | null;
  caseNum?: string;
  /** @format guid */
  filingId?: string | null;
  confirmationNum?: string;
  /** @format date-time */
  date?: string;
  /** @format guid */
  assignmentId?: string | null;
  assignmentName?: string;
  tags?: QueueTag[];
  caseDesc?: string;
  caseStatus?: string;
  caseType?: string;
  filerName?: string;
  /** @format int32 */
  docketNum?: number;
  docketDesc?: string;
  /** @format date-time */
  suspenseDate?: string | null;
  dlirType?: string;
  /** @format guid */
  judgeId?: string | null;
  judgeName?: string;
  docs?: FilingListResponseDoc[];
  hasNotes?: boolean;
}

export interface QueueTag {
  /** @format guid */
  id?: string;
  label?: string;
  /** @format guid */
  queueId?: string;
}

export interface QueueListQuery {
  /** @format guid */
  queueId?: string;
  bookMarksOnly?: boolean;
  description?: string | null;
  caseStatus?: ReportsCaseStatus;
  caseType?: ReportsCaseType;
  /** @format date-time */
  dateFrom?: string | null;
  /** @format date-time */
  dateTo?: string | null;
  showSuspenseDate?: boolean;
  showRemoved?: boolean;
  /** @format guid */
  assignmentId?: string | null;
  /** @format guid */
  judgeId?: string | null;
  tags?: string[];
}

export interface QueueUserList {
  /** @format guid */
  userId?: string;
  name?: string;
  emailAddress?: string;
  role?: QueuePermissions;
  roleStr?: string;
  userType?: UserTypes;
  userTypeStr?: string;
  /** @format int32 */
  assignmentCount?: number;
  queues?: SelectionValueOfGuid[];
  assignedQueues?: QueueAssignmentList[];
}

export interface QueueAssignmentList {
  /** @format guid */
  queueId?: string;
  queueType?: QueueType;
  queueName?: string;
  role?: QueuePermissions;
  roleName?: string;
}

export interface QueueUserQuery {
  role?: QueuePermissions | null;
  userType?: UserTypes | null;
}

export interface QueueAssignCase {
  /** @format guid */
  caseId?: string;
}

export interface QueueAssignment {
  /** @format guid */
  queueId?: string;
  permission?: QueuePermissions;
}

export interface QueueBatchAssignmentOfQueueAssignment {
  /** @format guid */
  userId?: string;
  queues?: QueueAssignment[];
}

export interface QueueBatchAssignmentOfGuid {
  /** @format guid */
  userId?: string;
  queues?: string[];
}

export interface UserModel {
  /** @format guid */
  id?: string | null;
  emailAddress?: string;
  prefixName?: string | null;
  firstName?: string;
  middleName?: string | null;
  lastName?: string;
  suffixName?: string | null;
  phoneNumber?: string;
  /** @format int32 */
  status?: number | null;
  address1?: string;
  address2?: string | null;
  city?: string;
  state?: string;
  zip?: string;
  userType?: string | null;
  hasMatches?: boolean | null;
  /** @format date-time */
  registrationDate?: string | null;
  userTypeCode?: UserTypes | null;
  userStatus?: string | null;
  userStatusCode?: UserStatus | null;
  termsAccepted?: boolean;
  /** @format date-time */
  termsAcceptedOn?: string | null;
  /** @format date-time */
  lastLogin?: string | null;
  attorneyInfo?: AttorneyModel | null;
  additionalEmails?: UserAdditionalEmailModel[] | null;
  preferences?: UserPreferenceModel[];
}

export enum UserStatus {
  New = 0,
  Active = 1,
  Inactive = 2,
  Deleted = 3,
  Rejected = 4,
  Pending = 5,
}

export interface AttorneyModel {
  /** @format guid */
  id?: string | null;
  barNumber?: string;
  barState?: string;
  organizationName?: string;
}

export interface UserAdditionalEmailModel {
  /** @format guid */
  id?: string | null;
  emailAddress?: string;
  status?: boolean | null;
}

export interface UserPreferenceModel {
  type?: UserPreferenceType;
  value?: number;
}

export enum UserPreferenceType {
  Unknown = 0,
  NotifyEService = 100,
  NotifyQueueRouting = 101,
  NotifyQueueUserAssign = 102,
  NotifyNoteTag = 103,
  NotifyCPMJudgeAssign = 104,
}

export interface ReportingDropdownsResponse {
  reports?: Reports[];
  caseTypes?: ReportsCaseType[];
  caseStatuses?: ReportsCaseStatus[];
  availableFiscalYears?: number[];
}

export enum Reports {
  EMAILS = 0,
  FILEDCASES = 1,
  VOUCHER = 2,
  CLAIMSTATUS = 3,
  CVSTAT = 4,
  FISCALYEAR = 5,
  FEERECONCILIATION = 6,
}

export interface EmailLogModel {
  /** @format guid */
  id?: string;
  /** @format date-time */
  emailDate?: string;
  subject?: string;
  emailAddress?: string;
  messageId?: string | null;
  emailType?: EmailTypes;
  caseNum?: string | null;
}

export enum EmailTypes {
  GENERIC = 0,
  APPROVAL = 1,
  REJECTION = 2,
  WELCOME = 3,
  REGISTRATION = 4,
  SUBMISSION = 5,
  TAGGED = 6,
  QUEUE = 7,
}

export enum SortableColumnEmailLog {
  Date = 0,
  To = 1,
  Subject = 2,
  CaseNum = 3,
}

export interface ReportingCaseResponse {
  /** @format guid */
  id?: string;
  /** @format date-time */
  dateAppealed?: string;
  caseNum?: string;
  claimant?: string;
  judge?: string;
  region?: string;
}

export interface DemoReportOfReportingVoucherResult {
  reportTitle?: string;
  /** @format date */
  dateReportRan?: string;
  /** @format date-time */
  dateFrom?: string;
  /** @format date-time */
  dateTo?: string;
  caseType?: ReportsCaseType;
  results?: ReportingVoucherResult[];
}

export interface ReportingVoucherResult {
  caseNumber?: string;
  caseType?: string;
  /** @format date-time */
  awardedDate?: string | null;
  /** @format decimal */
  awardedAmount?: number;
  claimants?: string[];
}

export interface DemoReportOfReportingClaimStatusResult {
  reportTitle?: string;
  /** @format date */
  dateReportRan?: string;
  /** @format date-time */
  dateFrom?: string;
  /** @format date-time */
  dateTo?: string;
  caseType?: ReportsCaseType;
  results?: ReportingClaimStatusResult[];
}

export interface ReportingClaimStatusResult {
  caseNumber?: string;
  caseType?: string;
  /** @format date-time */
  suspenseDate?: string | null;
  subStatus?: string;
  claimants?: string[];
  judgeName?: string;
  commissionerName?: string;
}

export interface ReportingCVStatResponse {
  quarterlyLabels?: Record<string, string>;
  demographics?: ReportingCVStatDemographics;
  performance?: ReportingCVStatPerformance;
  expenses?: ReportingCVStatCompensationExpenses[];
  expenseColumns?: ReportingCVStatCompensationExpense[];
  otherExpenseDescs?: ReportingCVStatOtherExpenseDesc[];
}

export interface ReportingCVStatDemographics {
  applications?: ReportingCVStatQuarterlyResult;
  victimBasis?: ReportingCVStatQuarterlyResult;
  ethnicity?: ReportingCVStatGroupResult[];
  ageRange?: ReportingCVStatGroupResult[];
  genders?: ReportingCVStatGroupResult[];
}

export interface ReportingCVStatQuarterlyResult {
  q1?: string;
  q2?: string;
  q3?: string;
  q4?: string;
}

export interface ReportingCVStatGroupResult {
  /** @format int32 */
  index?: number;
  formatting?: ReportsFormatting;
  label?: string;
  counts?: ReportingCVStatQuarterlyResult;
}

export enum ReportsFormatting {
  NORMAL = 0,
  BOLD = 1,
  ITALICS = 2,
  UNDERLINE = 3,
}

export interface ReportingCVStatPerformance {
  generalProcedure?: ReportingCVStatQuarterlyResult;
  appsReceived?: ReportingCVStatQuarterlyResult;
  appsApproved?: ReportingCVStatQuarterlyResult;
  appsDenied?: ReportingCVStatQuarterlyResult;
  safeApps?: ReportingCVStatQuarterlyResult;
  denialReasons?: ReportingCVStatGroupResult[];
  denialReasonsDesc?: string;
}

export interface ReportingCVStatCompensationExpenses {
  /** @format int32 */
  index?: number;
  expense?: ReportingCVStatCompensationExpense[];
}

export interface ReportingCVStatCompensationExpense {
  /** @format int32 */
  index?: number;
  value?: string;
}

export interface ReportingCVStatOtherExpenseDesc {
  crimeType?: string;
  descriptions?: string;
}

export interface DemoReportOfReportingFiscalYearResult {
  reportTitle?: string;
  /** @format date */
  dateReportRan?: string;
  /** @format date-time */
  dateFrom?: string;
  /** @format date-time */
  dateTo?: string;
  caseType?: ReportsCaseType;
  results?: ReportingFiscalYearResult[];
}

export interface ReportingFiscalYearResult {
  claimant?: string;
  caseNumber?: string;
  claimStatus?: string;
  caseType?: string;
  judge?: string;
  commissioner?: string;
}

export interface ReportingFeeReconciliation {
  /** @format date-time */
  transactionDate?: string;
  name?: string;
  email?: string;
  /** @format int32 */
  confirmationNum?: number;
  transactionId?: string;
  caseNum?: string;
  claimType?: string;
  /** @format decimal */
  feeCharged?: number;
}

export interface ReportingDispositionResponse {
  columnData?: ReportingDispositionColumn[];
  rowData?: ReportingDispositionRow[];
}

export interface ReportingDispositionColumn {
  /** @format guid */
  id?: string;
  name?: string;
}

export interface ReportingDispositionRow {
  dispositions?: ReportingDispositionItem[];
}

export interface ReportingDispositionItem {
  /** @format guid */
  id?: string;
  name?: string;
  /** @format int32 */
  amount?: number;
}

export interface ReportingExportParams {
  reportType?: Reports;
  /** @format date-time */
  dateFrom?: string | null;
  /** @format date-time */
  dateTo?: string | null;
  includeJudgeless?: boolean;
  /** @format guid */
  emailUserFilter?: string | null;
  /** @format guid */
  regionId?: string | null;
  descendingSort?: boolean | null;
  emailLogSortColumn?: SortableColumnEmailLog | null;
  filedCaseColumn?: SortableColumnCase | null;
  regionSortColumn?: SortableColumnCase | null;
  reportCaseType?: ReportsCaseType | null;
  reportCaseStatus?: ReportsCaseStatus | null;
  fiscalYearStatusOptional?: boolean | null;
  fiscalYearJudgeCommOptional?: boolean | null;
  fiscalYear?: string | null;
}

export interface ReportingRegionResponse {
  /** @format guid */
  id?: string;
  status?: CaseStatus;
  statusStr?: string;
  caseNum?: string;
  /** @format guid */
  regionId?: string | null;
  regionName?: string;
  /** @format guid */
  programAreaId?: string | null;
  /** @format date-time */
  dateAppealed?: string;
}

export interface UserListRequest {
  dateFrom?: string;
  dateTo?: string | null;
  userType?: UserTypes[] | null;
  userStatus?: UserStatus[] | null;
  searchBy?: string | null;
}

export interface UserRejectionModel {
  /** @format guid */
  userId?: string;
  rejectionReason?: string | null;
}

export interface UserConnectionResponse {
  /** @format guid */
  connectionId?: string;
  /** @format guid */
  userId?: string;
  userName?: string;
  userType?: UserTypes;
  userStatus?: UserStatus;
}

export interface UserConnectionPostRequest {
  /** @format guid */
  fromUserId?: string;
  /** @format guid */
  toUserId?: string;
}

export interface UserConnectionPostRequestBatch {
  /** @format guid */
  fromUserId?: string;
  toUserIds?: string[];
}

export interface UserDropdowns {
  userRoles?: SelectionValueOfUserTypes[];
  queueUserTypes?: SelectionValueOfNullableUserTypes[];
  queues?: SelectionValueOfGuid[];
  queueRoles?: SelectionValueOfNullableQueuePermissions[];
}

export interface SelectionValueOfUserTypes {
  value?: UserTypes;
  label?: string;
}

export interface UserNotificationResponse {
  /** @format guid */
  id?: string;
  /** @format date-time */
  dateAdded?: string;
  pinned?: boolean;
  read?: boolean;
  content?: string;
  subject?: string;
}
